import { render, staticRenderFns } from "./productGroupOrderReturn.vue?vue&type=template&id=7f31b6ef&scoped=true"
import script from "./productGroupOrderReturn.vue?vue&type=script&lang=js"
export * from "./productGroupOrderReturn.vue?vue&type=script&lang=js"
import style0 from "./productGroupOrderReturn.vue?vue&type=style&index=0&id=7f31b6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f31b6ef",
  null
  
)

export default component.exports